import { RedactedTaxIdentifierSchema } from "@redotech/redo-model/outbound-labels/customs";
import * as z from "zod/v4";

export const deleteTaxIdentifiers = {
  name: "deleteTaxIdentifiers" as const,
  input: z.object({ identifierIds: z.array(z.string()) }),
  output: z.object({ identifiers: z.array(RedactedTaxIdentifierSchema) }),
};
